import { List, Popper, Typography } from '@dls/react-core';
import { LinearProgress } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { SyncState } from '../../../api/studykit';
import { SyncStateListItem } from './sync-state-list-item';

interface SyncStatePopoverProps {
  open: boolean;
  error: boolean;
  anchorElement?: HTMLElement;
  syncStates?: SyncState[];
  onTriggerConfiguration: (configId: string) => void;
}

const StyledPopper = styled(Popper)`
  margin-top: 28px !important;

  &::before {
    content: '';
    position: absolute;
    margin-top: -20px;
    background-color: white;
    left: 50%;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    transform: translate(-50%, 50%) rotate(-45deg) !important;
    clip-path: polygon(
      -10px -10px,
      calc(100% + 10px) -10px,
      calc(100% + 10px) calc(100% + 10px)
    ) !important;
  }
`;
export const SyncStatePopover: React.FC<SyncStatePopoverProps> = ({
  anchorElement,
  open,
  error,
  syncStates,
  onTriggerConfiguration,
}) => {
  return (
    <StyledPopper anchorEl={anchorElement} open={open} placement="bottom">
      {error ? (
        <div>
          <Typography dls_contenttype="signal" dls_contentstate="Error" style={{ padding: 16 }}>
            Something went wrong fetching sync states. Please reload.
          </Typography>
        </div>
      ) : syncStates ? (
        <List>
          {syncStates.length ? (
            syncStates.map((s, idx) => (
              <SyncStateListItem
                key={s.configId}
                state={s}
                isLast={idx === syncStates.length - 1}
                onClick={onTriggerConfiguration}
              />
            ))
          ) : (
            <Typography style={{ padding: 16 }}>No configurations yet</Typography>
          )}
        </List>
      ) : (
        <LinearProgress variant="indeterminate" />
      )}
    </StyledPopper>
  );
};
